import RequestWizard from '@/cms/components/requestWizard';
import StatusCheck from './views/StatusCheck';

export default [
  { path: '/', component: RequestWizard },
  { path: '/check-status', component: StatusCheck }
];
